import React from 'react';
import {List} from 'components';
import {Organization} from 'api/types/organisationTypes';

type OrganizationListProps = {
  data?: Organization[];
  onClick: (id?: string) => () => void;
  className?: string;
};

function OrganizationList({data, onClick, className}: OrganizationListProps) {
  const items = data
    ? data.map(
        ({
          name,
          id,
          maxContentCreators,
          maxLearners,
          currentManagers,
          currentContentCreators,
          currentLearners,
        }) => ({
          title: name,
          subtitle: `${currentManagers} administrators, ${currentContentCreators}/${maxContentCreators} content creators,  ${currentLearners}/${maxLearners} learners`,
          onClick: onClick(id),
        })
      )
    : [];

  return (
    <div className={`overflow-auto h-full-24 ${className || ''}`}>
      <div className="w-full lg:w-7/12 m-auto">
        <List className="w-full py-2">
          {items.map((item, i) => (
            <List.Item data={item} key={`${item.title}${i}`} />
          ))}
        </List>
      </div>
    </div>
  );
}

export default OrganizationList;
